// extracted by mini-css-extract-plugin
module.exports = {"container":"FormNumber_container__32Vu2","label":"FormNumber_label__2gFvT","description":"FormNumber_description__Q3IT5","inputContainer":"FormNumber_inputContainer__36mH5"};